// メッセージMap
export const MessageMap = {
    "accept_start": "実習期間（開始）",
    "accept_end": "実習期間（終了）"
};